var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container set-full-height",attrs:{"id":"app"}},[_c('fresh-relevance-tracking'),_c('header-menu'),_c('router-view'),_c('help-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }